import React from 'react';
import { Modal } from '@good/ui/core';
import { CreateAgreementLinkModalBody } from './create-agreement-link-modal-body';

interface CreateAgreementLinkModalProps {
  opened: boolean;
  onClose: () => void;
  historyId?: string | null;
}

export const CreateAgreementLinkModal = ({ opened, onClose, historyId }: CreateAgreementLinkModalProps) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title='Send service agreement to customer'
      cancelProps={{
        onClick: onClose,
        label: 'Close',
      }}
    >
      {historyId ? <CreateAgreementLinkModalBody historyId={historyId} /> : null}
    </Modal>
  );
};
